import React from 'react';
import PropTypes from 'prop-types';
import lodash from 'lodash';
import { Search } from 'react-feather';

/*
   Nav page search: flattens the (nested) sidebar config into leaf links and
   filters them by name or section trail as the user types, so "rules" surfaces
   every rules page. Ported (AOE-free) twins carry a NEW badge instead of the
   old "(KEEP)" suffix; "keep" and "new" still surface them via a hidden search
   token. Access is still enforced by the caller (section type gate + per-item
   AccessControl).
*/

// Loose matching: lowercase and strip everything non-alphanumeric, so
// "job feed", "jobfeed" and "job-feed" all hit the same pages. Keys are
// precomputed once per item; the query normalizes once per keystroke.
export const normalizeSearchText = (text) => `${ text }`.toLowerCase().replace(/[^a-z0-9]/g, '');

export const flattenNavItems = (items, trail = [], sectionType = null) => {
   const flat = [];
   (items || []).forEach((item) => {
      if (!lodash.isObject(item)) { return; }
      const type = item.type || sectionType;
      const subItems = item.subItems || [];
      if (lodash.isString(item.path) && item.path.length > 0) {
         flat.push({
            name: item.name,
            path: item.path,
            trail: trail.join(' › '),
            searchKey: normalizeSearchText(`${ item.name } ${ trail.join(' ') } ${ item.ported ? 'keep new' : '' }`),
            access: item.access,
            deprecating: item.deprecating,
            deprecatingText: item.deprecatingText,
            ported: item.ported,
            isComingSoon: item.isComingSoon,
            type,
         });
      }
      if (subItems.length > 0) {
         flat.push(...flattenNavItems(subItems, [...trail, item.name].filter(Boolean), type));
      }
   });
   return flat;
};

export const filterNavItems = (flatItems, query) => {
   const q = normalizeSearchText(query);
   if (!q) { return []; }
   return flatItems.filter((item) => item.searchKey.includes(q));
};

const SideNavSearch = ({ query, onQueryChange }) => {
   return (
      <li className='sidebar-item sidebar-search'>
         <div className='sidebar-search-control'>
            <Search size={ 15 } aria-hidden='true'/>
            <input
               type='search'
               className='form-control form-control-sm sidebar-search-input'
               placeholder='Search pages...'
               aria-label='Search pages'
               value={ query }
               onChange={ (e) => onQueryChange(e.target.value) }
            />
         </div>
      </li>
   );
};

SideNavSearch.propTypes = {
   query: PropTypes.string.isRequired,
   onQueryChange: PropTypes.func.isRequired,
};

export default SideNavSearch;
